import { NavLink, useSearchParams } from "react-router-dom";

import { cn } from "@/lib/utils";

type TabNavigationProps = React.HTMLAttributes<HTMLDivElement> & {
  options: {
    label: string | React.ReactElement;
    to: string;
    disabled?: boolean;
  }[];
};

export function TabNavigation({
  className,
  options,
  ...props
}: TabNavigationProps) {
  const [searchParams] = useSearchParams();
  const allSearchParams = Object.fromEntries(searchParams.entries());

  const searchParamsString = Object.entries(allSearchParams)
    .map(([key, value]) => `${key}=${value}`)
    .join("&");

  return (
    <div
      className={cn(
        "flex items-center justify-start space-x-2 overflow-y-auto",
        className,
      )}
      {...props}
    >
      {options.map((option) => (
        <NavLink
          to={{
            pathname: option.to,
            search: searchParamsString,
          }}
          key={option.to}
          className={({ isActive }) =>
            cn(
              "text-nowrap rounded-sm bg-transparent px-4 py-2 text-sm font-semibold text-muted hover:bg-accent hover:text-accent-foreground",
              isActive &&
                "pointer-events-none bg-primary-foreground text-primary dark:bg-accent dark:text-accent-foreground",
              option.disabled &&
                "pointer-events-none cursor-not-allowed opacity-30",
            )
          }
        >
          {option.label}
        </NavLink>
      ))}
    </div>
  );
}
